// extracted by mini-css-extract-plugin
module.exports = {"confirmationText":"styles_confirmationText__wYLuU","buttonsContainer":"styles_buttonsContainer__4FvP_","button":"styles_button__Pg09b"};